const REFERRAL_STORAGE_KEY = "partner_referral";

class ReferralService {
  /**
   * Store partner referral data in localStorage
   */
  setReferral(referralData) {
    try {
      const data = {
        partner_id: referralData.partner_id,
        partner_code: referralData.partner_code,
        partner_name: referralData.partner_name || null,
        referral_token: referralData.referral_token || null,
        expires_at: referralData.expires_at,
        created_at: new Date().toISOString(),
      };

      localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(data));
      return true;
    } catch (error) {
      console.error("Error storing referral:", error);
      return false;
    }
  }

  /**
   * Get partner referral data from localStorage
   */
  getReferral() {
    try {
      const data = localStorage.getItem(REFERRAL_STORAGE_KEY);

      if (!data) {
        return null;
      }

      const referral = JSON.parse(data);

      // Check if referral has expired
      if (referral.expires_at && new Date(referral.expires_at) < new Date()) {
        this.clearReferral();
        return null;
      }

      return referral;
    } catch (error) {
      console.error("Error getting referral:", error);
      return null;
    }
  }

  /**
   * Clear referral data from localStorage
   */
  clearReferral() {
    try {
      localStorage.removeItem(REFERRAL_STORAGE_KEY);
      return true;
    } catch (error) {
      console.error("Error clearing referral:", error);
      return false;
    }
  }

  /**
   * Check if referral exists and is valid
   */
  hasValidReferral() {
    const referral = this.getReferral();
    return referral !== null;
  }

  /**
   * Get partner code for form auto-fill
   */
  getPartnerCode() {
    const referral = this.getReferral();
    return referral ? referral.partner_code : "";
  }

  /**
   * Get partner ID for registration
   */
  getPartnerId() {
    const referral = this.getReferral();
    return referral ? referral.partner_id : null;
  }
}

const referralService = new ReferralService();

export default referralService;
